import { render, staticRenderFns } from "./remove-document.component.vue?vue&type=template&id=3ba7f148&"
import script from "./remove-document.component.vue?vue&type=script&lang=ts&"
export * from "./remove-document.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports